import { render, staticRenderFns } from "./DynamicFieldInputs.vue?vue&type=template&id=2567b16d&scoped=true&"
import script from "./DynamicFieldInputs.vue?vue&type=script&lang=js&"
export * from "./DynamicFieldInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2567b16d",
  null
  
)

export default component.exports